<template>
	<details class="accordion mb-2">
		<summary>
			<div
				class="tab:flex-col tab:items-start flex w-full items-center justify-between"
			>
				<div class="text-color-gray4 text-[14px] font-normal">
					<i class="fa-solid fa-user fa-fw mr-1" />{{
						supportLogData.user_name
					}}
				</div>
				<div class="text-color-gray4 text-[12px] font-normal">
					<i class="fa-solid fa-clock fa-fw mr-1" />{{
						supportLogData.created_at
					}}
				</div>
			</div>
		</summary>
		<div class="accordion_inner relative">
			<div class="text-color-gray4 flex text-[12px] font-normal">
				更新者：{{ supportLogData.last_update_user_name }}&ensp;{{
					supportLogData.updated_at
				}}
			</div>
			<div>{{ supportLogData.content }}</div>

			<div class="flex justify-end">
				<button type="button" class="supportButton" @click="supportLogEdit">
					<i class="fa-solid fa-pen fa-fw fa-lg ml-1" />
				</button>
				<button
					type="button"
					class="supportButton delete ml-4"
					@click="supportLogDeleteModalOpen"
				>
					<i class="fa-solid fa-trash fa-fw fa-lg ml-1" />
				</button>
			</div>
		</div>
	</details>
</template>

<script setup>
import { onMounted } from "vue";

const emit = defineEmits(["supportLogEdit", "supportLogDeleteModalOpen"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	supportLogData: Object
});

function supportLogEdit() {
	emit("supportLogEdit", props.supportLogData);
}

function supportLogDeleteModalOpen() {
	emit("supportLogDeleteModalOpen", props.supportLogData);
}

/* ---------------------------------------------------------------------------
	mounted
---------------------------------------------------------------------------- */
onMounted(() => {});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;

.supportButton {
	min-width: 32px;
	min-height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: $bg-white2;
	border-radius: 100px;
	color: $color-orange2;
	cursor: pointer;
	border: 1px solid $bg-orange2;
	@include trans(0.3);
	&:hover {
		background: $bg-orange2;
		color: $color-white2;
		@include trans(0.3);
	}
	&.delete {
		color: $color-gray4;
		border-color: $bg-gray4;
		&:hover {
			color: $color-white2;
			background: $bg-gray4;
		}
	}
}
</style>
